import RootStore from "store/rootStore";
import { fabric } from "fabric";
import { POINT_CLOSE_LIMIT } from "./labelerSegmentationUiStore";

const mouseDownHandler = (e: fabric.IEvent, store: RootStore) => {
  if (
    store.labelerSegmentationStore.isReadOnly ||
    store.labelerSegmentationUiStore.imageLoadError
  ) {
    return;
  }

  const {
    fabricSegmentationStore: { canvas, selectPolygonAtPointer },
    labelerSegmentationUiStore: {
      createPolygon,
      addPoint,
      polygonDoneCount,
      setTagSelectedIndex,
      findPolygonNotDone,
      selectMode,
      moveInZoom,
      setActivePolygon,
    },
    labelerSegmentationStore: { changeMotif, tags },
  } = store;

  // const activeObject = selectPolygonAtPointer(e);

  // if (selectMode) {
  //   setActivePolygon(activeObject);
  // }
  const activeObject = canvas.getActiveObject();
  setActivePolygon(activeObject);

  if (
    moveInZoom ||
    (selectMode && !activeObject) ||
    _closeToExistingPoint(e, store)
  ) {
    return;
  }

  if (selectMode && activeObject) {
    const tagIndex = tags.findIndex((tag) => tag.color === activeObject.fill);
    if (tagIndex > -1) {
      setTagSelectedIndex(tagIndex);
    }
    addPointInMiddlle(e, store);
    return;
  }

  const point = canvas.getPointer(e.e);
  const numberPolygonDone = polygonDoneCount();
  const polyNotDone = findPolygonNotDone(numberPolygonDone);

  if (polyNotDone) {
    addPoint(polyNotDone, point);
  } else {
    changeMotif(null, false);
    createPolygon([point]);
  }
};

const addPointInMiddlle = (e: fabric.IEvent, store: RootStore) => {
  const {
    fabricSegmentationStore: { newPoint, removeNewPoint, canvas },
    labelerSegmentationUiStore: { polygons, setPolygons },
  } = store;

  const activeObject = canvas.getActiveObject();

  if (!newPoint || !activeObject) return;

  const { x, y } = canvas.getPointer(e.e);

  const { leftPoint, rightPoint, object, newIndex } = newPoint;

  // on supprime le newPoint pour éviter qu'il reste en place après l'action
  removeNewPoint();

  // il y a un placeholder de nouveau point sur un segment
  const pointCenter = { x: object.left, y: object.top };

  // est que le clic a eu lieu a proximité du centre un point a créer
  const threshold = 5;
  if (x < pointCenter.x - threshold || x > pointCenter.x + threshold) return;
  if (y < pointCenter.y - threshold || y > pointCenter.y + threshold) return;

  // oui, il faut creer le pointxx
  // const selectedPol =
  const polygonSelected = polygons.find(
    (poly: any) => poly.labelValue === activeObject.name
  );

  if (!polygonSelected) {
    return;
  }

  const newPolygons = polygons.map((p: any) => {
    if (p.labelValue !== activeObject.name) return p;

    const points = [...p.points];
    points.splice(newIndex, 0, { x: pointCenter.x, y: pointCenter.y });

    return { ...p, points };
  });
  setPolygons(newPolygons);
};

const _closeToExistingPoint = (e: fabric.IEvent, store: RootStore) => {
  const {
    labelerSegmentationStore: { tags },
    labelerSegmentationUiStore: { tagSelectedIndex, polygons },
    fabricSegmentationStore: { canvas },
  } = store;

  const { x, y } = canvas.getPointer(e.e);
  const labelName = tags[tagSelectedIndex].legend;
  const notDonePolygon = polygons.find(
    (p) => p.labelValue.indexOf(labelName) !== -1 && !p.done
  );
  if (!notDonePolygon) return false;

  const { zoom } = store.labelerSegmentationUiStore;
  const closeLimit = POINT_CLOSE_LIMIT / zoom;
  return notDonePolygon.points.reduce(
    (memo: any, point: any, index: number, datas: any) => {
      const { x: xP, y: yP } = point;
      return (
        memo ||
        (Math.abs(x - xP) <= closeLimit && Math.abs(y - yP) <= closeLimit)
      );
    },
    false
  );
};

export default mouseDownHandler;
